module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Right-6b11a7f312b328aad11495e2cba6633e.svg";